import React from 'react';
import { NavSearch } from './nav-search';
import styled from 'styled-components';
import {
  FlexColumn,
  FlexRow,
  SubtitleText,
  useMatchMedia,
} from '@make-software/cspr-design';
import { NavMetrics } from './nav-metrics';
import { TextAdsBanner } from '../../components/ads-banner/text-ads-banner';
import { HomeAdsBanner } from '../../components';
import { Trans, useTranslation } from 'react-i18next';

const SearchWithBannerContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    maxWidth: theme.maxWidth,
    width: ['100%', '100%', '89%', '100%'],
    padding: ['16px 16px 24px', '16px 32px 0px', '54px 0 40px', '54px 0 40px'],
    margin: 0,
    justifyContent: 'space-between',
    alignItems: ['center', 'center', 'end', 'end'],
  })
);

const MetricsContainer = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: ['row'],
    alignItems: 'center',
    width: '100%',
    padding: ['16px', '16px 32px', '16px 56px 16px', '16px 0'],
    margin: 0,
  })
);

const DetailsSearchbarContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    maxWidth: theme.maxWidth,
    padding: '16px 0',
    justifyContent: 'space-between',
  })
);

const HomeTextAdContainer = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: ['100%', '100%', '60%'],
  })
);

const DetailsTextAdContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    maxWidth: theme.maxWidth,
    padding: ['0 16px', '0 32px', '0 56px', '0'],
  })
);

interface SearchWithAdBannerProps {
  isHome?: boolean;
}

const SearchWithAdBanner = ({ isHome = false }: SearchWithAdBannerProps) => {
  const screenType = useMatchMedia(['mobile', 'tablet', 'desktop'], []);
  const isDesktop = screenType === 'desktop';
  const { t } = useTranslation();

  if (isHome) {
    return (
      <SearchWithBannerContainer>
        <HomeTextAdContainer itemsSpacing={20}>
          <FlexColumn gap={16}>
            <SubtitleText size={1} variation={'white'} tag={'h1'}>
              <Trans t={t}>Casper Blockchain Explorer</Trans>
            </SubtitleText>
            <NavSearch />
          </FlexColumn>
          <TextAdsBanner />
        </HomeTextAdContainer>
        {isDesktop && <HomeAdsBanner screenType={screenType} />}
      </SearchWithBannerContainer>
    );
  }
  return (
    <DetailsSearchbarContainer>
      <MetricsContainer>
        {isDesktop && <NavMetrics />}
        <NavSearch />
      </MetricsContainer>
      <DetailsTextAdContainer>
        <TextAdsBanner />
      </DetailsTextAdContainer>
    </DetailsSearchbarContainer>
  );
};

export default SearchWithAdBanner;
